// extracted by mini-css-extract-plugin
export var section = "styles-module--section--KTt+R";
export var bottomSectionWrapper = "styles-module--bottomSectionWrapper--SIrDv";
export var bottomSection = "styles-module--bottomSection--gRz2i";
export var textWrapper = "styles-module--textWrapper--ieV2G";
export var description = "styles-module--description--X4lkP";
export var smallCaps = "styles-module--smallCaps--iobgS";
export var heading = "styles-module--heading--qOsBa";
export var descriptionStyle = "styles-module--descriptionStyle--ED34K";
export var buttonWrapper = "styles-module--buttonWrapper--Izvlv";